import { SAVE_INFO } from '../ActionsType';

export function SaveInfo(info) {
  return {
    type: SAVE_INFO,
    info
  };
}
